import React from "react";
import { Link } from "react-router-dom";
import { scrollToHashTarget } from "../../utils/scrollToHashTarget";

export default function CelebrationContact() {
  const handleContactClick = (event) => {
    const alreadyAtContact =
      window.location.pathname === "/" && window.location.hash === "#contact";

    if (alreadyAtContact) {
      // No location change for the Link's navigation to react to — scroll directly.
      event.preventDefault();
      scrollToHashTarget("contact");
    }
    // Otherwise, let <Link>'s default React Router navigation proceed untouched.
  };

  return (
    <section className="w-full py-16 md:py-24">
      <div className="mx-auto theme-container text-center">
        <span className="section-title-top-tag" data-aos="fade-up">
          Interested in technology and innovation?
        </span>
        <h2
          className="mx-auto mt-6 max-w-2xl text-34 font-semibold text-main-black md:text-48"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          Get in touch
        </h2>
        <div className="mt-8 flex justify-center" data-aos="fade-up" data-aos-delay="200">
          <Link
            to="/#contact"
            onClick={handleContactClick}
            className="group inline-flex items-center gap-2 rounded-[8px] bg-[var(--celebration-yellow)] px-8 py-3 font-semibold text-main-black shadow-card-sm transition-transform duration-300 hover:-translate-y-[2px] focus:outline-none focus-visible:ring-2 focus-visible:ring-purple focus-visible:ring-offset-2"
          >
            Contact Us
            <svg
              className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
